module.exports = __webpack_public_path__ + "static/a+o-body-96d47b1d704983416a3604f868f4fd0c.png";